require('./cardPaymentPurchaseDeferralSliderSection.scss');
require('./cardPaymentPurchaseDeferralSliderSection.override.scss');

const PropTypes = require('prop-types');
//@vendor
const React = require('react');
const classNames = require('classnames');

//@commons
const { OKButton } = require('components/commons/OKButton/OKButton');
const { OneLineSymbolAmount } = require('commonsComponents/oneLineSymbolAmount');
const OKSliderInput = require('commonsComponents/OKSliderInput');
const { LoadingSection } = require('commonsComponents/loadingSection');
const OKModal = require('components/commons/OKModal/OKModal');
const OKTooltip = require('components/commons/OKTooltip/OKTooltip');
//@constants
const TRANSLATION_KEY_PREFIX = 'cardPaymentPurchaseDeferralSliderSection-';
const { MULTIPLE_QUOTA, TAE, TIN, THREE_QUOTA, NO_PACK_KEY, PACK_KEY } = require('constants/lavanda');
const { DEFERRAL_PAYMENT_OPTION_ACTION_EVENT, DEFERRAL_PAYMENT_QUOTA_INPUT_ACTION_EVENT, DEFERRAL_PAYMENT_QUOTA_SLIDER_ACTION_EVENT } = require('constants/tagging');

//helpers
const { formatAmountObject, getPlainAmountObject } = require('utilities/currencyHelper');
const { getDeferralOptionTag, getNumberOfQuotas, getTinAndTaeValues } = require('utilities/lavandaHelper');
const { recordLink } = require('utilities/tagging');
//core
const { FormattedText, formatText, getLanguage } = require('core/i18n').i18n;
//@compontents
const CardPaymentPurchaseDeferralTable = require('components/cards/cardPaymentPurchaseDeferral/cardPaymentPurchaseDeferralTable/cardPaymentPurchaseDeferralTable');
const DeferralSelector = require('components/deferralSelector/deferralSelector');

class CardPaymentPurchaseDeferralSliderSection extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            showModal: false
        };

        this.handleToggleModal = this.handleToggleModal.bind(this);
        this.handleQuotaQuantityChange = this.handleQuotaQuantityChange.bind(this);
        this.handleDeferralSelectorChange = this.handleDeferralSelectorChange.bind(this);
        this.handleInputOnFocus = this.handleInputOnFocus.bind(this);
    }


    buildValuesAndButtonSection(interests, quotaValue, quotaQuantity, financedPurchased) {
        const { immCardPaymentPurchaseDeferral, isLavandaCard, lavandaEnabled, quotaStep } = this.props;
        const plainAmountQuotaObject = getPlainAmountObject(quotaValue);
        const plainAmountInterestObject = getPlainAmountObject(interests);
        const plainAmountFinancedPurchaseObject = getPlainAmountObject(financedPurchased);
        const language = getLanguage();
        const isLavandaFlow = lavandaEnabled && isLavandaCard;
        let content = <LoadingSection />;

        if (!immCardPaymentPurchaseDeferral.getIn(['steps', quotaStep, 'isFetching'])) {
            const totalAmountOwed = immCardPaymentPurchaseDeferral.getIn(['steps', quotaStep, 'totalAmount']);
            const plainAmountTotalAmountOwedObject = getPlainAmountObject(totalAmountOwed);

            content = (
                <section>
                    <section className="card-payment-purchase-deferral-slider-section__values-section">
                        <div className="card-payment-purchase-deferral-slider-section__value">
                            <FormattedText value={TRANSLATION_KEY_PREFIX + 'quotaValue'} />
                            <div className="card-payment-purchase-deferral-slider-section__value-amount">
                                <OneLineSymbolAmount
                                    amountObject={plainAmountQuotaObject}
                                    language={language}
                                    amountObjectFormatted={formatAmountObject(plainAmountQuotaObject, true)} />
                            </div>
                        </div>
                        {  isLavandaFlow &&
                            <React.Fragment>
                                <div className="card-payment-purchase-deferral-slider-section__value">
                                    <FormattedText value="lavanda-lavanda_totalQuotas" />
                                    <div className="card-payment-purchase-deferral-slider-section__value-amount">
                                        {quotaQuantity}
                                    </div>
                                </div>
                                <div className="card-payment-purchase-deferral-slider-section__value">
                                    <FormattedText value="lavanda-lavanda_totalAmountOwed" />
                                    <div className="card-payment-purchase-deferral-slider-section__value-amount">
                                        <OneLineSymbolAmount
                                            positiveAmount
                                            amountObject={plainAmountTotalAmountOwedObject}
                                            language={language}
                                            amountObjectFormatted={formatAmountObject(plainAmountTotalAmountOwedObject, true)}
                                        />
                                    </div>
                                </div>
                                <div className="card-payment-purchase-deferral-slider-section__value">
                                    <FormattedText value="lavanda-lavanda_creditAmount" />
                                    <div className="card-payment-purchase-deferral-slider-section__value-amount">
                                        <OneLineSymbolAmount
                                            positiveAmount
                                            amountObject={plainAmountFinancedPurchaseObject}
                                            language={language}
                                            amountObjectFormatted={formatAmountObject(plainAmountFinancedPurchaseObject, true)}
                                        />
                                    </div>
                                </div>
                            </React.Fragment>
                        }
                        <div className={
                            classNames('card-payment-purchase-deferral-slider-section__value card-payment-purchase-deferral-slider-section__value--interests', {
                                'pull-right': !isLavandaFlow 
                            })}
                        >
                            <FormattedText value={TRANSLATION_KEY_PREFIX + 'interests'} />
                            <div className="card-payment-purchase-deferral-slider-section__value-amount">
                                <OneLineSymbolAmount
                                    amountObject={plainAmountInterestObject}
                                    language={language}
                                    amountObjectFormatted={formatAmountObject(plainAmountInterestObject, true)} />
                            </div>
                        </div>
                    </section>
                    <section className="card-payment-purchase-deferral-slider-section__button-section">
                        <OKButton modifier="link-complementary" onClick={this.handleToggleModal}>
                            <FormattedText value={TRANSLATION_KEY_PREFIX + 'amortizationChart'} />
                        </OKButton>
                    </section>
                    {isLavandaFlow && 
                        <div className="card-payment-purchase-deferral-slider-section__legal">
                            <FormattedText value="lavanda-lavanda_typeOfAmortization" />
                        </div>
                    }
                </section>
            );
        }

        return content;
    }

    handleQuotaQuantityChange(quantity, sliderChanged) {
        const { isLavandaCard } = this.props;

        isLavandaCard && sliderChanged && recordLink(window.utag_last_name, DEFERRAL_PAYMENT_QUOTA_SLIDER_ACTION_EVENT, `${quantity} cuotas`);
        this.props.setQuotaQuantity(quantity);
    }

    handleInputOnFocus(){
        const { isLavandaCard, lavandaEnabled } = this.props;
        const isLavandaFlow = lavandaEnabled && isLavandaCard;

        isLavandaFlow && recordLink(window.utag_last_name, DEFERRAL_PAYMENT_QUOTA_INPUT_ACTION_EVENT, 'cuotas');
    }

    handleDeferralSelectorChange(option){
        const { setDeferralOption, setQuotaQuantity } = this.props;
        const choosenOption = getNumberOfQuotas(option);

        recordLink(window.utag_last_name, DEFERRAL_PAYMENT_OPTION_ACTION_EVENT, getDeferralOptionTag(option));
        setQuotaQuantity(choosenOption);
        setDeferralOption(option);
    }

    handleToggleModal() {
        this.setState({
            showModal: !this.state.showModal
        });
    }

    render() {
        const {
            chosenDeferral,
            immCard,
            immCardPaymentPurchaseDeferral,
            immGlobalVariables,
            isLavandaCard,
            lavandaEnabled,
            quotaStep,
            threeMonthQuotaAmount,
            totalFinanced,
        } = this.props;
        const isLavandaFlow = lavandaEnabled && isLavandaCard;
        const quotaInformation = immCardPaymentPurchaseDeferral.getIn(['steps', quotaStep]);
        const installmentList = quotaInformation.get('installmentsList');
        const isFetching= immCardPaymentPurchaseDeferral.getIn(['steps', quotaStep, 'isFetching']);
        const parameters = !!immGlobalVariables && immGlobalVariables.getIn(['variables', 'parameters']);
        const { [TAE]: interestTae, [TIN]: interestTin } = !!parameters ? getTinAndTaeValues(isLavandaFlow, THREE_QUOTA, immCard, parameters) : { [TAE]: "", [TIN]: "" };
        const isPack = immCard.get('isDiamond') || immCard.get('isPremium');
        const legalNotesKey = isPack ? PACK_KEY : NO_PACK_KEY;
        const legalNotes = isLavandaFlow && (
            <div className="card-payment-purchase-deferral-slider-section__legal">
                <FormattedText value={legalNotesKey} injectedStrings={[interestTin, interestTae]}/>
            </div>
        );
        
        let content = <LoadingSection />;

        if (!installmentList.isEmpty()) {
            const interests = quotaInformation.get('totalInterests');
            const quotaValue = quotaInformation.get('quotaMonthly');
            const quotaQuantity = quotaInformation.get('installmentQuantity');
            const installmentMaximum = quotaInformation.get('installmentMaximum');
            const sliderLabel = formatText(TRANSLATION_KEY_PREFIX + 'title');
            const financedPurchased = totalFinanced;
            const valuesSection = this.buildValuesAndButtonSection(interests, quotaValue, quotaQuantity, financedPurchased);
            const isDisabled = this.state.showLoadingSection;
            const isDiamondOrPremiumCard = immCard.get('isDiamond') || immCard.get('isPremium');
            const tooltipTranslation = isDiamondOrPremiumCard ? 'tooltipAmountsDiamondPremium' : 'tooltipAmounts';
            const unit = formatText('cardPaymentPurchaseDeferralSliderSection-cardPaymentPurchaseDeferralSliderSection_fee');
            const maxLabel = `${formatText('cardPaymentPurchaseDeferralSliderSection-cardPaymentPurchaseDeferralSliderSection_max')} ${installmentMaximum}`;
            const tooltip = !isLavandaFlow ? (
                <OKTooltip
                    content={`${TRANSLATION_KEY_PREFIX}${tooltipTranslation}`}
                    offset={[15, 0]}
                    placement="right"
                />
            ) : null;
            
            let slider;
            const showSlider = !lavandaEnabled || !isLavandaCard || chosenDeferral === MULTIPLE_QUOTA && !isFetching;

            if (showSlider){
                slider =  (
                    <section className="card-payment-purchase-deferral-slider-section__slider">
                        <OKSliderInput
                            min={2}
                            max={installmentMaximum}
                            maxLabel={maxLabel}
                            defaultValue={quotaQuantity}
                            onChange={this.handleQuotaQuantityChange}
                            disabled={isDisabled}
                            extraInfo={tooltip}
                            title={sliderLabel}
                            unit={unit}
                            onFocus={this.handleInputOnFocus}
                        />
                    </section>
                );
            }

            content = (
                <section className="card-payment-purchase-deferral-slider-section">
                    <OKModal
                        content={<CardPaymentPurchaseDeferralTable immInstallments={installmentList} />}
                        isOpen={this.state.showModal}
                        onCloseCallback={this.handleToggleModal}
                        size="large"
                        title="cardPaymentPurchaseDeferralTable-title"
                    />
                    { isLavandaFlow &&
                        <DeferralSelector 
                            onClick={this.handleDeferralSelectorChange}
                            selected={chosenDeferral}
                            threeMonthQuotaAmount={threeMonthQuotaAmount}
                            tae={interestTae}
                            tin={interestTin}
                        />
                    }
                    {slider}
                    {valuesSection}
                    {legalNotes}
                </section>
            );
        }else if (isLavandaFlow){
            content = (
                <React.Fragment>
                    <DeferralSelector 
                        onClick={this.handleDeferralSelectorChange}
                        selected={0}
                        threeMonthQuotaAmount={threeMonthQuotaAmount}
                        tae={interestTae}
                        tin={interestTin}
                    />
                    {isFetching && <LoadingSection /> }
                    {legalNotes}
                </React.Fragment>
            );
        }

        return content;
    }
}

CardPaymentPurchaseDeferralSliderSection.propTypes = {
    chosenDeferral: PropTypes.string,
    immCard: PropTypes.object.isRequired,
    immCardPaymentPurchaseDeferral: PropTypes.object.isRequired,
    immGlobalVariables: PropTypes.object,
    isLavandaCard: PropTypes.bool,
    lavandaEnabled: PropTypes.bool,
    quotaStep: PropTypes.number.isRequired,
    setDeferralOption: PropTypes.func,
    setQuotaQuantity: PropTypes.func,
    threeMonthQuotaAmount: PropTypes.object,
    totalFinanced: PropTypes.object,
};

CardPaymentPurchaseDeferralSliderSection.defaultProps = {
    isLavandaCard: false,
    lavandaEnabled: false,
    totalFinanced: null,
    immGlobalVariables: null,
}

module.exports = CardPaymentPurchaseDeferralSliderSection;